import { Get, Post } from '@/service/request/server';
import { envConfig } from '../../../env';

export function getSwaggerResources(apiPrefix) {
    return Get(envConfig.formalServer + `/${apiPrefix}/swagger-resources`, {})
}

export function getSwaggerApiInfo(apiUrl) {
    return Get(envConfig.formalServer + `${apiUrl}`, {})
}
